import { useState } from "react";
import { GenerateurGrilleTool } from "../labo/GenerateurGrilleTool";
import type { LaboDraw } from "../labo/laboStats";
import { KmTease } from "../ui/KmTease";
import { limitsFor } from "../../helpers/entitlements";
import styles from "./GenerateurIsland.module.css";
import { LienAnalyseCombinaison } from "../LienAnalyseCombinaison";

/** Session supposée : drapeau posé par l'application à la connexion. Sans lui, aucune requête. */
export function sessionSupposee(): boolean {
  try {
    return window.localStorage.getItem("has_session") === "true";
  } catch {
    return false;
  }
}

/** Hauteur réservée pendant la vérification de la session et le chargement de l'outil complet. */
export function Reserve() {
  return (
    <div className={styles.reserve} data-generateur-reserve aria-busy="true">
      Chargement du générateur…
    </div>
  );
}

/** Grilles suivies par le compte gratuit, en toutes lettres (quotas du serveur). */
function grillesSuivies(n: number): string {
  return n === 1 ? "une grille" : `jusqu'à ${n} grilles`;
}

/**
 * Générateur public (anonyme ou session expirée) et invitation au compte gratuit (encart commun).
 * Une grille obtenue : le bouton devient « Garder cette grille », le lien d'inscription porte ses
 * numéros (?numbers=, même intention que le widget « Testez vos numéros ») et le serveur
 * l'enregistre dans Mes grilles après l'inscription.
 */
export function GenerateurPublic({ tiragesDesc, exemple = false }: { tiragesDesc: LaboDraw[]; exemple?: boolean }) {
  const [grille, setGrille] = useState<number[] | null>(null);
  const gratuit = limitsFor("free");
  const suite = `générez-en jusqu'à ${gratuit.generatorMaxGrids} à la fois, à partir de vos numéros de départ.`;
  return (
    <>
      <GenerateurGrilleTool tiragesDesc={tiragesDesc} exemple={exemple} onGrid={setGrille} />
      {/* Grille obtenue : son historique dans l'analyse de combinaison. */}
      {grille && <p className={styles.analyser}><LienAnalyseCombinaison numeros={grille} enLigne natif /></p>}
      <div className={styles.invitation}>
        {grille ? (
          <KmTease
            key="grille"
            source="generateur_grille"
            feature="generateur"
            compact
            next="/generateur-grille-keno/"
            title="Le générateur complet, avec un compte gratuit"
            gain={`Gardez cette grille dans Mes grilles et ${suite}`}
            ctaLabel="Garder cette grille"
            params={{ numbers: [...grille].sort((a, b) => a - b).join(",") }}
          />
        ) : (
          <KmTease
            key="public"
            source="generateur_public"
            feature="generateur"
            compact
            next="/generateur-grille-keno/"
            title="Le générateur complet, avec un compte gratuit"
            gain={`Suivez ${grillesSuivies(gratuit.maxCombinations)} dans Mes grilles et ${suite}`}
          />
        )}
      </div>
    </>
  );
}
